import { useState } from "react";
import { createReactivation } from "../../api/customer";
import Box from "../../components/Box";
import AlertBox from "../../components/AlertBox";
import MainLayout from "../../components/layouts/MainLayout";
import ImageUploader from "../../components/ImageUploader";
import CustomerSearchReactivation from "../../components/customer/CustomerSearchReactivation";
import DropdownSelectHelper from "../../components/technician/DropdownSelectHelper";
import DropdownSelectTechnician from "../../components/technician/DropdownSelectTechnician";

export default function ReactivationPage() {
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [loading, setLoading] = useState(false);

  const [technician, setTechnician] = useState(null);
  const [helper, setHelper] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [form, setForm] = useState({
    customer_id: "",
    reactivation_date: "",
    notes: "",
    speedtest_url: "",
    handover_form_url: "",
    device_switch_url: "",
  });

  const onChangeImg = (type, image_url) => {
    setForm({ ...form, [type]: image_url });
  };

  const onChangeCustomer = (customer) => {
    setSelectedCustomer(customer);
    setForm({ ...form, customer_id: customer ? customer.id : "" });
  };

  const resetData = () => {
    setTechnician(null);
    setHelper(null);
    setSelectedCustomer(null);
    setForm({
      customer_id: "",
      reactivation_date: "",
      notes: "",
      speedtest_url: "",
      handover_form_url: "",
      device_switch_url: "",
    });
  };

  const onSubmitData = (event) => {
    event.preventDefault();

    if (!form.customer_id) {
      setAlert({
        show: true,
        message: "Silahkan cari dan pilih pelanggan terlebih dahulu",
        type: "danger",
      });
      return;
    }

    if (!technician) {
      setAlert({
        show: true,
        message: "Silahkan pilih teknisi terlebih dahulu",
        type: "danger",
      });
      return;
    }

    if (!form.handover_form_url) {
      setAlert({
        show: true,
        message: "Foto form serah terima wajib diupload",
        type: "danger",
      });
      return;
    }

    let formData = {
      customer_id: form.customer_id,
      technician_id: technician.value,
      reactivation_date: form.reactivation_date,
      attachments: [
        {
          type: "speedtest",
          speedtest_url: form.speedtest_url,
        },
        {
          type: "handover_form",
          handover_form_url: form.handover_form_url,
        },
        {
          type: "device_switch",
          device_switch_url: form.device_switch_url || null,
        },
      ],
    };

    if (helper) {
      formData.helper_id = helper.value;
    }

    if (form.notes) {
      formData.notes = form.notes;
    }

    sendData(formData);
  };

  const sendData = async (form_data) => {
    setLoading(true);
    try {
      let { data } = await createReactivation(form_data);
      setAlert({
        show: true,
        message: data.message,
        type: "success",
      });
      resetData();
    } catch (error) {
      let message = "";
      if (error.response) {
        let { data } = error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message: message, type: "danger" });
      topFunction();
    }
    setLoading(false);
  };

  const topFunction = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  return (
    <MainLayout>
      <div className="container-fluid">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 className="h3 mb-0 text-gray-800">Reaktivasi Pelanggan</h1>
        </div>

        <div className="row">
          <div className="col">
            <AlertBox {...alert} setAlert={setAlert} />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-8">
            <Box title="Form Reaktivasi">
              <form onSubmit={(event) => onSubmitData(event)}>
                <div className="row">
                  <div className="col-md-6">
                    <CustomerSearchReactivation
                      value={selectedCustomer}
                      onChange={onChangeCustomer}
                    />

                    <div className="form-group">
                      <label>Tanggal Reaktivasi</label>
                      <input
                        type="date"
                        className="form-control"
                        required
                        value={form.reactivation_date}
                        onChange={(event) =>
                          setForm({ ...form, reactivation_date: event.target.value })
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label>Teknisi</label>
                      <DropdownSelectTechnician
                        value={technician}
                        onChangeValue={(selected) => setTechnician(selected)}
                      />
                    </div>
                    <div className="form-group">
                      <label>Helper</label>
                      <DropdownSelectHelper
                        value={helper}
                        onChangeValue={(selected) => setHelper(selected)}
                      />
                    </div>
                    <div className="form-group">
                      <label>Catatan (Opsional)</label>
                      <textarea
                        rows="4"
                        className="form-control"
                        value={form.notes}
                        onChange={(event) => setForm({ ...form, notes: event.target.value })}
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label>
                        Foto Form Serah Terima <span className="text-danger">*</span>
                      </label>
                      <ImageUploader
                        image={form.handover_form_url}
                        type="handover_form_url"
                        onChangeImg={onChangeImg}
                        required={true}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label>
                        Speedtest <span className="text-danger">*</span>
                      </label>
                      <ImageUploader
                        image={form.speedtest_url}
                        type="speedtest_url"
                        onChangeImg={onChangeImg}
                        required={true}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <label>Foto Perangkat & Switch (Opsional)</label>
                      <ImageUploader
                        image={form.device_switch_url}
                        type="device_switch_url"
                        onChangeImg={onChangeImg}
                      />
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-end">
                  <button className="btn btn-primary" disabled={loading}>
                    {loading ? "Menyimpan ..." : "Simpan Reaktivasi"}
                  </button>
                </div>
              </form>
            </Box>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
